import { useQuery } from '@apollo/client';

import parseISO from 'date-fns/parseISO';

import { modelDetailTimeRangePollInterval } from '../../config';

import {
  FETCH_PIPELINE_VERSION_QUERY,
  GET_PIPELINE_BY_NAME_QUERY,
  transformPipelineResponse,
  transformPipelineVersionResponse,
} from '../../utils/model_server';
import useWorkspaceContext from '../../components/workspaces/WorkspaceContext/WorkspaceContext';


const getLatestDeployment = pipelineVersionDeployments => pipelineVersionDeployments?.reduce((latestDeployment, currentDeployment) => {
  if (!latestDeployment || parseISO(currentDeployment.deployedAt) > parseISO(latestDeployment.deployedAt)) {
    return currentDeployment;
  }
  return latestDeployment;
}, null)

export const usePipelineDataQuery = (pipelineId, _version) => {
  const { currentWorkspaceId } = useWorkspaceContext();

  const {
    loading,
    error,
    data,
    refetch,
  } = useQuery(GET_PIPELINE_BY_NAME_QUERY, {
    variables: { pipeline_id: pipelineId, workspace_id: currentWorkspaceId },
    pollInterval: modelDetailTimeRangePollInterval,
  });

  const pipeline = !loading && !error && data.pipeline.length === 1 ? transformPipelineResponse(data.pipeline[0]) : null;
  return {
    pipeline, loading, error, refetch
  }
}

export const usePipelineHistoryQuery = (pipelineId, pipelineVersion, workspaceID) => {
  const pipelineVersionQuery = useQuery(FETCH_PIPELINE_VERSION_QUERY, {
    variables: { pipeline_id: pipelineId, workspace_id: workspaceID },
    pollInterval: modelDetailTimeRangePollInterval,
    fetchPolicy: 'cache-and-network'
  });

  const pipelineVersions = pipelineVersionQuery?.data?.pipeline_version?.map(transformPipelineVersionResponse);
  const selectedPipelineVersion = pipelineVersions?.find(({ version }) => version === pipelineVersion)
  const deploymentID = selectedPipelineVersion?.id;
  const latestPipelineDeployment = selectedPipelineVersion?.deployments ? getLatestDeployment(selectedPipelineVersion.deployments) : null;
  return {
    loading: pipelineVersionQuery?.loading,
    error: pipelineVersionQuery?.error,
    pipelineSteps: selectedPipelineVersion?.steps,
    pipelineHistory: pipelineVersions || [],
    deploymentID,
    latestPipelineDeployment,
    refetchHistoryQuery: pipelineVersionQuery?.refetch
  }
}
